<p-dialog
  [visible]="true"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="first-time-setup-dialog"
>
  <ng-template pTemplate="header">
    <div class="setup-dialog-header">
      <img src="/images/jenz-logo.png" class="setup-logo" alt="Jenz" />
      <h2 class="setup-title">{{ 'firstTimeSetup.title' | translate }}</h2>
      <p class="setup-subtitle">{{ 'firstTimeSetup.subtitle' | translate }}</p>
    </div>
  </ng-template>

  <div class="setup-dialog-body">
    <div class="language-grid">
      @for (lang of languages; track lang.value) {
        <div
          class="language-card"
          [class.selected]="selectedLanguage()?.value === lang.value"
          (click)="selectLanguage(lang)"
        >
          {{ lang.label }}
        </div>
      }
    </div>

    <div class="terms-section">
      <p-checkbox
        [ngModel]="termsAccepted()"
        (ngModelChange)="termsAccepted.set($event)"
        [binary]="true"
        inputId="terms-checkbox"
      />
      <label for="terms-checkbox" class="terms-label">
        {{ 'firstTimeSetup.privacyAccept' | translate }}
        <a [href]="privacyPolicyUrl()" target="_blank" class="terms-link">{{ 'firstTimeSetup.privacyPolicy' | translate }}</a>
      </label>
    </div>

    <jenz-button
      [label]="'firstTimeSetup.getStarted' | translate"
      type="primary"
      class="full-width"
      [disabled]="!canProceed()"
      (onClick)="proceed()"
    />
  </div>
</p-dialog>
